import React, { useState, useEffect } from 'react';

const OzonPage = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const linkUrl = 'https://www.ewe.rs/pretraga?q=ozon';
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div className="ozon-page" style={{ textAlign: 'center', width: '100%', backgroundColor: '#000000ed' }}>
            <a href={linkUrl} target="_blank" rel="noopener noreferrer">
                <img
                    src={isMobile ? 'https://resource.ewe.rs/media/mobilna-verzija-LP-prikaz.jpg' : 'https://resource.ewe.rs/media/Ozon-NL-final.jpg'}
                    alt="Ozon"
                    style={{ height: 'auto', display: 'inlineBlock', maxWidth: '100%' }}
                />
            </a>
        </div>
    );
};

export default OzonPage;
